import { inject } from 'vue';
import { globalDataKey, globalDataType } from '@/global';

export function useGlobalData () {
  return inject(globalDataKey) as globalDataType;
}
